import React, {useEffect, useState} from 'react';
import {Select, SelectContent, SelectItem, SelectTrigger} from '../../ui-components/Select';
import {ChevronDownIcon} from '@radix-ui/react-icons';
import {UserAccess} from '../../screens/settings/users/types';
import {FolderPermission, folderPermissionChange} from '../../actions/pure/media';
import Tracker from '../../lib/analytics/tracker';
import {EventNames, EventProperty} from '../../lib/analytics/events';

interface UserItemProps {
    org_uid: string;
    user: UserAccess;
    initialPermission: string;
    folderInfo: any;
}

const UserPermission: React.FC<UserItemProps> = ({org_uid, user, folderInfo, initialPermission}) => {
    const getInitialPermission = () => {
        const share = folderInfo.shares.find((share: any) => share.user_email === user.email);
        return share ? share.access_level : 'NO_ACCESS';
    };
    const [permission, setPermission] = useState('');

    useEffect(() => {
        setPermission(getInitialPermission());
    }, [folderInfo]);
    const handlePermissionChange = async (value: string) => {
        setPermission(value);
        const folderPermissionReq: FolderPermission = {
            orgUid: org_uid,
            folderUid: folderInfo.uid,
            userEmail: user.email,
            accessLevel: value,
            action: value !== 'REVOKE' ? 'GRANT' : 'REVOKE',
        };
        await folderPermissionChange(folderPermissionReq);
        Tracker.trackEvent(EventNames.FOLDER_PERMISSION_CHANGED, {
            [EventProperty.FolderUserEmail]: user.email,
            [EventProperty.FolderAccess]: value,
        });
    };

    return (
        <div className='my-6 flex justify-between'>
            <div className='flex items-center justify-between gap-4'>
                <span className='rounded-[100%] border-[2px] border-[#E0E0DF] px-[10px] text-[27px] font-[600] text-[#E0E0DF]'>
                    {user.first_name.charAt(0)}
                </span>
                <div className='flex flex-col'>
                    <span className='text-[20px] font-[500] text-[#3E3C37]'>
                        {user.first_name} {user.last_name}
                    </span>
                    <span className='text-[20px] font-[500] text-[#7D7C78]'>{user.email}</span>
                </div>
            </div>
            <Select onValueChange={handlePermissionChange}>
                <SelectTrigger noStyle={true} width={16} height={16} color={'#FFFFFF'} className='outline-none'>
                    <div className='flex items-center justify-center text-[20px] font-[500] text-[#7D7C79]'>
                        {permission === 'READ' && 'Can View'}
                        {permission === 'WRITE' && 'Can Write'}
                        {permission === 'REVOKE' && 'Revoke Access'}
                        {permission === 'NO_ACCESS' && 'No Access'}
                        <ChevronDownIcon />
                    </div>
                </SelectTrigger>
                <SelectContent className='outline-none'>
                    <SelectItem key='READ' value='READ'>
                        Can View
                    </SelectItem>
                    <SelectItem key='WRITE' value='WRITE'>
                        Can Write
                    </SelectItem>
                    <SelectItem key='REVOKE' value='REVOKE'>
                        Revoke Access
                    </SelectItem>
                </SelectContent>
            </Select>
        </div>
    );
};

export default UserPermission;
